export class GetSnapshotResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshot",
            "baseName": "snapshot",
            "type": "Snapshot",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetSnapshotResponse.attributeTypeMap;
    }
    constructor() {
    }
}
